// Shared navigation config, used by both MobileLayout (bottom nav) and
// DesktopLayout (sidebar) so the two never drift out of sync.

export const NAV_ITEMS = [
  { id: "dashboard",    icon: "📊", label: "Overview"     },
  { id: "weekly",       icon: "📅", label: "Weekly"       },
  { id: "transactions", icon: "💳", label: "Transactions" },
  { id: "accounts",     icon: "🏦", label: "Accounts"     },
  { id: "advisor",      icon: "🪩", label: "Advisor"      },
  { id: "settings",     icon: "⚙️", label: "Settings"     },
];

// Analytical-only pages (shown in the desktop sidebar). Stubs for now — the real
// pages arrive in Phase 4.
export const ANALYTICS_ITEMS = [
  { path: "/analytics/overview", icon: "🗓️", label: "Year Overview"      },
  { path: "/analytics/monthly",  icon: "🔎", label: "Monthly Deep Dive"  },
  { path: "/analytics/forecast", icon: "📈", label: "Forecast"           },
  { path: "/analytics/trends",   icon: "📉", label: "Trends"             },
];
